import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { CommonState } from 'src/app/shared/services/common-state.service';
import { environment } from 'src/environments/environment';
import { FileDocument } from '../../models/company/document.model';

@Injectable({
  providedIn: 'root',
})
export class DocumentService extends CommonState<FileDocument> {
  private readonly http = inject(HttpClient);

  private apiUrl = `${environment.springAppUrl}/document`;

  constructor() {
    super(FileDocument);
  }

  public uploadPhoto(document: FileDocument) {
    return this.http.post<FileDocument>(this.apiUrl, document);
  }

  public findById(uuid: string) {
    return this.http.get<FileDocument>(`${this.apiUrl}/${uuid}`);
  }

  public findByIdThumbnail(uuid: string) {
    return this.http.get<FileDocument>(`${this.apiUrl}/${uuid}/thumbnail`);
  }
}
